export class CpModule {
  constructor(
    name: string,
    path: string,
    available: boolean,
    iconPath: string,
    translateKey: string,
    isMainModule: boolean = true
  ) {
    this.name = name;
    this.path = path;
    this.available = available;
    this.iconPath = iconPath;
    this.translateKey = translateKey;
    this.isMainModule = isMainModule;
  }

  name: string;
  path: string;
  available: boolean;
  iconPath: string;
  translateKey: string;
  isMainModule: boolean;
}
